<style scoped>
 div.port-patch-parent-00 {
   width: 100%;
   heigh: 40px;
   display:flex;
   justify-content: center;
   align-items: center;
 }
 div.port-patch-parent-00 > div.port-patch-head-00 {
   width: 70%;
   display:flex;
   justify-content: flex-start;
   align-items: center;
 }
 .port-patch-head-00.title-margin {
   padding-left: 15px;
 }
 div.port-patch-parent-00 > div.port-patch-tail-00 {
   width: 30%;
   display:flex;
   justify-content: flex-end;
 }
 div.patch-list-00 {
   height:300px;
   overflow:scroll;
   padding: 0;
   margin: 0;
   border: 1px solid #ddd;
   border-radius: 3px;
 }
 .v-dialog > .v-card > .v-card__title {
   background-color: rgb(243,159,137);
   color: rgb(255,248,238);
 }
 div.midi-device-check-button {
   display:flex;
   justify-content: flex-end;
   align-items: center;
   height: 42px;
 }
 .ewi4ks-patch-no {
   display:flex;
   justify-content: center;
   align-items: center;
 }
 th.table-column-00 {
   width: 96px;
   padding: 0 8px;
 }
 th.table-column-03 {
   width: 50px;
   padding: 0 16px 0 0;
 }
 th.table-column-04 {
   width: 50px;
   padding: 0 32px 0 0;
 }
 td.table-column-01 {
   width: 140px;
 }
 td.table-column-03 {
   width: 50px;
   padding: 0 16px 0 0;
 }
.v-tabs-items {
   width: 100%;
 }
 div.patch_range_left {
   width: 50%;
   display: flex;
   justify-content: flex-start;
   padding-left: 10px;
 }
 div.patch_range_right {
   width: 50%;
   display: flex;
   justify-content: flex-end;
   padding-right: 10px;
 }
 .v-label-white {
   /*color: 'red lighten-5'!important;*/
   font-size: 15px;
 }
 .badge-00 {
   /*background-color: rgba(236, 228, 225, 1);*/
   background-color: rgba(246, 245, 234, 0.8);
   border-radius: 5px;
   border: solid 1px #1A237E;
   min-width: 93px;
 }
 div.ble-supported-device-notice {
   margin: 10px 5px;
   color: #616161;
 }
</style>
<template>
  <div>

    <!-- vv -- snackbar -- vv -->
    <v-snackbar
        multi-line
        v-model="snackbar.show"
        :top="snackbar.top"
        :timeout="snackbar.timeout"
    >
      <div :class="snackbar.textClass"><v-icon :color="snackbar.icon.color">{{ snackbar.icon.name }}</v-icon> &nbsp; {{ snackbar.text }} &nbsp; <v-btn x-small color="primary" :style="snackbar.btnStyle" @click="closeSnackbarThenOpenDeviceCommunicationDialog()"><v-icon small>mdi-midi-port</v-icon>&nbsp; Port & Patch</v-btn></div>
      <template v-slot:action="{ attrs }">
        <v-btn
            icon
            v-bind="attrs"
            @click="snackbar.show = false"
        >
          <v-icon class="snackbar.textClass">mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
    <!-- ^^ -- snackbar -- ^^ -->

    <v-row justify="center">
      <v-col cols="4" sm="4" class="justify-align-center">

        <!-- send to device -->
        <v-dialog
            v-model="midiSyncToDeviceMenu.show"
            persistent
            max-width="600"
        >
          <v-card class="pa-5">
            <div class="port-patch-parent-00 mb-4">
              <div class="port-patch-head-00 title-margin">
                <p class="text-h6 text--primary ma-0">
                  Sync Patch to Device
                </p>
              </div>
              <div class="port-patch-tail-00 justify-align-center">
                <v-btn
                    icon
                    :disabled="midiSyncToDeviceMenu.closeBtnDisabled"
                    color="red lighten-5"
                    @click="closePatchToDeviceDialog()"
                >
                  <v-icon color="red">mdi-close</v-icon>
                </v-btn>
              </div>
            </div>
            <v-card-text class="ma-0 pb-0 pl-5 pr-5">
              <div class="text--primary">
                <div class="justify-align-center">

                  <!-- vvv -- MIDI PORT SELECTOR -- vvv -->
                  <v-list three-line subheader>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>
                          <v-icon :color="midi_on_state_change.color" small>mdi-midi-port</v-icon> MIDI Ports to Sync The Patch &nbsp;
                          <v-btn text x-small outlined @click="refreshListMidiDevices()"><v-icon small>mdi-reload</v-icon>&nbsp;Refresh</v-btn>
                        </v-list-item-title>
                        <v-list-item-subtitle>{{ midiSyncToDeviceMenu.text }}</v-list-item-subtitle>
                      <v-tabs v-model="connection_method_tab">
                        <v-tab href="#cable-midi"><v-icon>mdi-cable-data</v-icon> &nbsp; USB MIDI</v-tab>
                        <v-tab href="#ble-midi"><v-icon>mdi-bluetooth</v-icon> &nbsp; BLE MIDI</v-tab>
                      </v-tabs>
                      <v-tabs-items v-model="connection_method_tab">
                        <v-tab-item value="cable-midi">
                           <!-- vvv -- [Cable tab here] -- vvv -->
                          <v-row class="mt-3">
                            <v-col cols="12" sm="6">
                              <v-select
                                  :disabled="select_midi_device_disabled"
                                  :items="midi_devices.inputs"
                                  hide-details
                                  label="INPUT PORT"
                                  v-model="sel_midi_device_input"
                                  required
                              ></v-select>
                            </v-col>
                            <v-col cols="12" sm="6">
                              <v-select
                                  :disabled="select_midi_device_disabled"
                                  :items="midi_devices.outputs"
                                  hide-details
                                  label="OUTPUT PORT"
                                  v-model="sel_midi_device_output"
                                  required
                              ></v-select>
                            </v-col>
                          </v-row>
                          <!-- vvv Use these ports button vvv -->
                          <div class="midi-device-check-button mt-5">
                            <v-spacer></v-spacer>
                            <v-alert
                                text
                                dense
                                dismissible
                                transition="scale-transition"
                                mode="out-in"
                                :type="midi_device_alert_message.type"
                                :value="midi_device_alert_message.show"
                                class="ma-0 mr-1"
                            >{{ midi_device_alert_message.text }}</v-alert>
                            <v-btn
                                :loading="is_checking_midi_device"
                                :disabled="select_midi_device_disabled"
                                color="blue darken-1"
                                text
                                @click="checkEwi4000sDevice(true)"
                            >
                              USE THESE PORTS
                            </v-btn>
                          </div>
                          <!-- ^^^ -- [Cable tab here] -- ^^^ -->
                        </v-tab-item>

                        <v-tab-item value="ble-midi">
                          <!-- vvv -- [BLE tab here] -- vvv -->
                          <v-row class="ma-5">
                            <v-col cols="12">
                              <div class="justify-align-center">
                                <v-btn
                                    :color="ble_button.color.btn"
                                    :class="ble_button.color.text"
                                    @click="startBleMidiSearch"
                                    :loading="ble_button.loading"
                                ><v-icon>{{ ble_button.icon }}</v-icon> &nbsp; {{ ble_button.text }}</v-btn>
                              </div>
                              <div class="justify-align-center ble-supported-device-notice">
                                <p>Support deiveces: <a href="https://jp.yamaha.com/products/music_production/accessories/md-bt01/index.html" target="_blank">Yamaha MD-BT01</a></p>
                              </div>
                              <div class="justify-align-center mt-2" style="height: 30px">
                                <v-alert
                                    text
                                    dense
                                    dismissible
                                    transition="scale-transition"
                                    mode="out-in"
                                    :type="midi_device_alert_message.type"
                                    :value="midi_device_alert_message.show"
                                    class="ma-0 mr-1"
                                >{{ midi_device_alert_message.text }}</v-alert>
                              </div>
                            </v-col>
                          </v-row>
                        </v-tab-item>
                        <!-- ^^^ -- [BLE tab here] -- ^^ -->
                      </v-tabs-items>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>

                </div>
              </div>
            </v-card-text>
            <v-divider class="mb-5"></v-divider>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                  text
                  color="primary"
                  :disabled="midiDeviceSelected"
                  :loading="midiSyncToDeviceMenu.loading"
                  @click="syncParamEditOnePatchToDevice()"
              >
                <!-- midiSyncToDeviceMenu.SyncBtnIsDisabled -->
                <v-icon>mdi-camera-flip</v-icon>&nbsp;Sync to Device
              </v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <!-- -->

        <!-- select midi device & patch -->
        <v-dialog
            v-model="midi_device_dialog"
            persistent
            max-width="800px"
        >
          <v-card>
            <v-overlay
                absolute
                :value="component_overly_w_dialog.show"
            >
              <div class="justify-align-center">
                <v-card
                    color="#ffffff"
                    class="mx-auto pl-10 pr-10 pt-5 pb-5"
                    max-width="344"
                >
                  <v-card-text>
                    <p class="text-h5 text--primary mb-5">
                      {{ component_overly_w_dialog.dialog_title }}
                    </p>
                    <div class="text--primary justify-align-center direction-column">
                      <v-progress-linear
                          :stream="component_overly_w_dialog.progressStream"
                          :buffer-value="component_overly_w_dialog.progressValue"
                          height="10"
                          :color="component_overly_w_dialog.progressColor"
                      ></v-progress-linear>
                      <p class="mt-5 mb-0">{{ component_overly_w_dialog.text }}</p>
                    </div>
                  </v-card-text>
                  <v-card-actions class="justify-align-center">
                    <v-btn
                        text
                        :color="component_overly_w_dialog.btnColor"
                        @click="cancelMultiplePatches()"
                    >
                      {{ component_overly_w_dialog.btnText }}
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </div>
            </v-overlay>
            <!-- -->

            <v-card-title class="communication-setting">
              <div class="port-patch-parent-00">
                <div class="port-patch-head-00">
                  <span class="text-h5">EWI 4000s MIDI Port and Patch</span>
                  &nbsp; <v-btn x-small icon v-on:click="dump_params()"><v-icon>mdi-text-box-outline</v-icon></v-btn>
                </div>
                <div class="port-patch-tail-00 justify-align-center">
                  <div class="pa-2 badge-00">
                    <v-checkbox
                        v-model="demoMode"
                        color="indigo"
                        hide-details
                        class="pa-0 ma-0"
                    >
                      <template v-slot:label>
                        <span class="v-label-indigo indigo--text">Demo</span>
                      </template>
                    </v-checkbox>
                  </div>
                  <div class="ml-15">
                    <v-btn
                        icon
                        color="red lighten-5"
                        @click="closeMidiDeviceDialog(false)"
                    >
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </div>
                </div>
              </div>
            </v-card-title>
            <v-divider></v-divider>
              <v-card-text>
              <v-container>
                <v-list three-line subheader>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>
                        <v-icon :color="midi_on_state_change.color" small>mdi-midi-port</v-icon> MIDI Ports &nbsp;
                        <v-btn text x-small outlined @click="refreshListMidiDevices()"><v-icon small>mdi-reload</v-icon>&nbsp;Refresh</v-btn>
                      </v-list-item-title>
                      <v-list-item-subtitle>Select EWI4000s's MIDI IN Port & OUT Port.</v-list-item-subtitle>
                      <!-- vvv Single selection cable or ble vvv -->
                      <!-- ^^^ Single selection cable or ble ^^^ -->
                      <v-tabs v-model="connection_method_tab">
                        <v-tab href="#cable-midi"><v-icon>mdi-cable-data</v-icon> &nbsp; USB MIDI</v-tab>
                        <v-tab href="#ble-midi"><v-icon>mdi-bluetooth</v-icon> &nbsp; BLE MIDI</v-tab>
                      </v-tabs>
                      <v-tabs-items v-model="connection_method_tab">
                        <v-tab-item value="cable-midi">
                           <!-- vvv -- [Cable tab here] -- vvv -->
                          <v-row class="mt-3">
                            <v-col cols="12" sm="6">
                              <v-select
                                  :disabled="select_midi_device_disabled"
                                  :items="midi_devices.inputs"
                                  hide-details
                                  label="INPUT PORT"
                                  v-model="sel_midi_device_input"
                                  required
                              ></v-select>
                            </v-col>
                            <v-col cols="12" sm="6">
                              <v-select
                                  :disabled="select_midi_device_disabled"
                                  :items="midi_devices.outputs"
                                  hide-details
                                  label="OUTPUT PORT"
                                  v-model="sel_midi_device_output"
                                  required
                              ></v-select>
                            </v-col>
                          </v-row>
                          <!-- vvv Use these ports button vvv -->
                          <div class="midi-device-check-button mt-5">
                            <v-spacer></v-spacer>
                            <v-alert
                                text
                                dense
                                dismissible
                                transition="scale-transition"
                                mode="out-in"
                                :type="midi_device_alert_message.type"
                                :value="midi_device_alert_message.show"
                                class="ma-0 mr-1"
                            >{{ midi_device_alert_message.text }}</v-alert>
                            <v-btn
                                :loading="is_checking_midi_device"
                                :disabled="select_midi_device_btn_disabled"
                                color="blue darken-1"
                                text
                                @click="checkEwi4000sDevice(true)"
                            >
                              USE THESE PORTS
                            </v-btn>
                          </div>
                          <!-- ^^^ -- [Cable tab here] -- ^^^ -->
                        </v-tab-item>
                        <v-tab-item value="ble-midi">
                          <!-- vvv -- [BLE tab here] -- vvv -->
                          <v-row class="ma-5">
                            <v-col cols="12">
                              <div class="justify-align-center">
                                <v-btn
                                    :color="ble_button.color.btn"
                                    :class="ble_button.color.text"
                                    @click="startBleMidiSearch"
                                    :loading="ble_button.loading"
                                ><v-icon>{{ ble_button.icon }}</v-icon> &nbsp; {{ ble_button.text }}</v-btn>
                              </div>
                              <div class="justify-align-center ble-supported-device-notice">
                                <p>Support deiveces: <a href="https://jp.yamaha.com/products/music_production/accessories/md-bt01/index.html" target="_blank">Yamaha MD-BT01</a></p>
                              </div>
                              <div class="justify-align-center mt-2" style="height: 30px">
                                <v-alert
                                    text
                                    dense
                                    dismissible
                                    transition="scale-transition"
                                    mode="out-in"
                                    :type="midi_device_alert_message.type"
                                    :value="midi_device_alert_message.show"
                                    class="ma-0 mr-1"
                                >{{ midi_device_alert_message.text }}</v-alert>
                              </div>
                            </v-col>
                          </v-row>
                        </v-tab-item>
                        <!-- ^^^ -- [BLE tab here] -- ^^ -->
                      </v-tabs-items>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
                <v-divider class="mb-5"></v-divider>

                <!-- -->
                <v-list three-line subheader>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title><v-icon small>mdi-format-list-bulleted</v-icon> Patch List
                        <!--
                        <v-btn icon color="blue-grey lighten-3"
                        @click="exportPatches">
                          <v-icon>mdi-export</v-icon>
                        </v-btn>
                        -->
                      </v-list-item-title>
                      <v-row>
                        <v-col cols="12" sm="12">

                          <!-- vvv -->
                          <div id="patch-list" class="patch-list-00">
                            <v-simple-table>
                              <template v-slot:default>
                                <thead>
                                  <tr>
                                    <th class="text-center table-column-00">

                                     <!-- -->
                                      <v-menu
                                          v-model="mutiple_fetch_menu.show"
                                          :close-on-content-click="false"
                                          top
                                          offset-y
                                      >
                                        <template v-slot:activator="{ on, attrs }">
                                          <v-btn
                                              v-bind="attrs"
                                              v-on="on"
                                              class="ma-2"
                                              outlined
                                              color="indigo darken-4"
                                              :disabled="midiDeviceSelected">
                                            <v-icon>mdi-download</v-icon>Multi
                                          </v-btn>
                                        </template>
                                        <v-card class="mx-auto">
                                          <v-card-text>
                                            <p class="text-h6 text--primary">
                                              Fetch Multiple Patches
                                            </p>
                                            <p>Select range of patch# to fetch.</p>
                                            <div class="text--primary">
                                              <div class="justify-align-center">
                                                <div class="patch_range_left">{{mutiple_fetch_menu.value[0]}} </div>
                                                <div class="patch_range_right">{{mutiple_fetch_menu.value[1]}} </div>
                                              </div>
                                              <v-range-slider
                                                  v-model="mutiple_fetch_menu.value"
                                                  thumb-color="indigo darken-1"
                                                  min="0"
                                                  max="99"
                                              ></v-range-slider>
                                            </div>
                                          </v-card-text>
                                          <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn
                                                text
                                                color="red"
                                                @click="mutiple_fetch_menu.show = false"
                                            >
                                              Cancel
                                            </v-btn>
                                            <v-btn
                                                text
                                                color="primary"
                                                @click="fetchMutiplePatches()"
                                            >
                                              Fetch
                                            </v-btn>
                                          </v-card-actions>
                                        </v-card>
                                      </v-menu>
                                      <!-- -->

                                    </th>
                                    <th class="text-center">
                                      Patch No
                                    </th>
                                    <th class="text-left">
                                      Patch Name
                                    </th>
                                    <th class="text-center table-column-03">Edit</th>
                                    <th class="text-center table-column-04"></th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr
                                      v-for="(item, idx) in storedPatchList"
                                      :key=idx
                                      :id="`patchno-${idx}`"
                                  >
                                    <td class="text-center">
                                      <v-tooltip left>
                                        <template v-slot:activator="{ on, attrs }">
                                          <v-btn icon
                                                 color="#252525"
                                                 :idx=idx
                                                 @click="fetchOnePatchFromEwi4ks(idx)"
                                                 v-bind="attrs"
                                                 v-on="on"
                                                 :disabled="midiDeviceSelected"
                                          ><v-icon>mdi-download</v-icon></v-btn>
                                        </template>
                                        <span>Fetch #{{ item.decoded.patchNo }}</span>
                                      </v-tooltip>
                                    </td>
                                    <td class="text-center table-column-01">{{ item.decoded.patchNo }}</td>
                                    <td>{{ item.decoded.patchNameDecoded }}</td>
                                    <td class="text-center table-column-03">
                                      <v-tooltip right>
                                        <template v-slot:activator="{ on, attrs }">
                                          <v-btn text
                                                 :idx=idx
                                                 :disabled=!item.decoded.fetched
                                                 @click="showOnePatchOnUi(idx)"
                                                 icon
                                                 v-bind="attrs"
                                                 v-on="on"
                                          ><v-icon>mdi-tune</v-icon></v-btn>
                                        </template>
                                        <span>Edit #{{ item.decoded.patchNo }}</span>
                                      </v-tooltip>
                                    </td>
                                    <td class="text-center" style="width: 50px; padding: 0 32px 0 0;">
                            <!--
                            <v-tooltip right>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn icon
                                       color="#252525"
                                       :idx=idx
                                       @click="fetchOnePatchFromEwi4ks(idx)"
                                       v-bind="attrs"
                                       v-on="on"
                                ><v-icon>{{ icons.mdiRefresh }}</v-icon></v-btn>
                              </template>
                              <span>Load Default</span>
                            </v-tooltip>
                            -->
                                    </td>
                                  </tr>
                                </tbody>
                              </template>
                            </v-simple-table>
                          </div>
                          <!-- ^^^ -->

                        </v-col>
                      </v-row>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>

              </v-container>
            </v-card-text>

            <!--
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                  color="blue darken-1"
                  text
                  @click="closeMidiDeviceDialog(false)"
              >
                CLOSE
              </v-btn>
            </v-card-actions>
            -->
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>
  </div>
</template>

<script>
 //import { mdiMidiPort, mdiDownload, mdiTune, mdiRefresh, mdiCableData, mdiBluetooth, mdiBluetoothConnect, mdiReload } from '@mdi/js'

 export default {
   name: 'MidiDeviceControls',
   props: [],
   data: () => ({
     timeoutToHide: 5500,
     demoModeDefault: false,
     snackbar: {
       show: false,
       top: true,
       timeout: -1,
       text: '',
       textClass: 'font-weight-bold white--text',
       btnStyle: 'display: unset;',
       icon:{
         name: 'mdi-check-circle',
         color: 'green'
       },
       iconSet: {
         error: {
           name: 'mdi-information',
           color: 'red'
         },
         warning: {
           name: 'mdi-alert',
           color: 'yellow'
         },
         success: {
           name: 'mdi-check-circle',
           color: 'green'
         }
       }
     },
     mutiple_fetch_isCanceled: false,
     mutiple_fetch_menu: {
       show: false,
       value: [0, 99]
     },
     midiSyncToDeviceMenu: {
       show: false,
       zIndex: 10,
       text: '',
       SyncBtnIsDisabled: true,
       loading: false,
       closeBtnDisabled: false
     },
     connection_method_tab: 'wired-midi',
     ble_button: {
       color: {
         btn: '', // primary
         text: ''
       },
       text: 'Connect',
       loading: false,
       icon: 'mdi-bluetooth'
     },
     /*
     icons: {
       mdiMidiPort: mdiMidiPort,
       mdiDownload: mdiDownload,
       mdiTune: mdiTune,
       mdiRefresh: mdiRefresh,
       mdiBluetooth: mdiBluetooth,
       mdiCableData: mdiCableData,
       mdiBluetoothConnect: mdiBluetoothConnect,
       mdiReload: mdiReload,
     },
     */
     midi_on_state_change: {
       color_set: {
         normal: '#212121',
         changed: 'deep-orange',
       },
       color: '#212121',
       timerId: null
     },
     select_midi_device_disabled: false,
     select_midi_device_btn_disabled: true,
     is_checking_midi_device: false,
     midi_device_dialog: false,
     component_overly_w_dialog: {
       dialog_title: 'Fetching Patches',
       text: '',
       btnText: 'Stop',
       btnColor: 'red',
       btnDisabled: true,
       progressValue: 0,
       progressValueNum: 0,
       progressStream: true,
       progressColor: 'indigo darken-1',
       show: false,
       closeDialogShowDuration: 2200,
       timerId: 0,
     },
     midi_device_alert_message: {
       text: '',
       type: 'success',
       show: false
     },
     midi_device_alert_message_show_duration: 5000, //msec
     patch_no: '',
     patch_no_conf: {
       min: 0, max: 99
     },
     patch_no_ewi: 1,
     patch_name: '',
     requestMIDIAccessOption: {sysex: true},
     midi_devices: {
       inputs: [],
       outputs: []
     },
     sel_midi_device_input: null,
     sel_midi_device_output: null,
     sel_midi_device: {
       input: -1,
       output: -1
     },
   }),
   computed: {
     demoMode: {
       get: function() {
         const demoMode = this.$store.getters.getDemoMode()
         this.$set(this.$data, 'select_midi_device_disabled', demoMode)

         // update param of disabled of "USE THESE PORTS" button
         // handle "midi_device_alert_message"
         if (demoMode) {
           const  tmp_midi_device_alert_message = {
             text: '',
             type: 'info',
             show: false
           }
           this.$set(this.$data, 'midi_device_alert_message', tmp_midi_device_alert_message)
           this.$set(this.$data, 'select_midi_device_btn_disabled', true)
         } else
         if (this.sel_midi_device_output==null || this.sel_midi_device_input==null) {
           this.$set(this.$data, 'select_midi_device_btn_disabled', true)
         } else {
           this.$set(this.$data, 'select_midi_device_btn_disabled', false)
         }

         return demoMode
       },
       set: function(value) {
         this.$store.commit('onUpdateDemoMode', {value: value})
         this.$router.app.$children[0].switchDemoDevicePatchesApp(value)
       }
     },
     midiDeviceSelected: {
       get: function() {
         const midi_devices = this.$store.getters.getConfigMidiDeveice()
         //console.log('[midi_devices]', midi_devices.input==null, midi_devices.output==null)
         if (this.$store.getters.getDemoMode()) {
           return true
         }
         if (midi_devices.input == null && midi_devices.output == null) {
           return true
         }
         return false
       }
     },
     storedPatchList: {
       get: function() {
         const patches = this.$store.getters.getAllStoredPatch()
         patches.forEach( (item, idx) => {
           if (typeof item.decoded.header != 'undefined'
               && typeof item.decoded.trailer_f7 != 'undefined') {
             patches[idx].decoded.fetched = true
           }
         })
         return patches
       }
     },
     workingPatch: {
       get: function() {
         return this.$store.getters.getWorkingPatchIdx()
       }
     },
   },
   watch: {
     'mutiple_fetch_menu.show'(newValue) {
       if (newValue) {
         this.$set(this.$data.mutiple_fetch_menu, 'value', [0, 99])
       }
     },
     'midi_device_alert_message.type'() {
       setTimeout( () => {
         this.$set(this.$data.midi_device_alert_message, 'show', false)
       }, this.midi_device_alert_message_show_duration)
     },
     patch_no(newValue) {
       const min = this.patch_no_conf.min
       const max = this.patch_no_conf.max
       if (min > newValue) {
         this.patch_no = min
       } else if (max < newValue) {
         this.patch_no = max
       }
       if (this.patch_no == 100) {
         this.patch_no_ewi = 0
       } else {
         this.patch_no_ewi = this.patch_no
       }
     },
     workingPatch() {
       //const working_idx = this.$store.getters.getWorkingPatchIdx()
       //const patch = this.$store.getters.getOneStoredPatch(working_idx)
       const workingPatch = this.$store.getters.getWorkingPatch()
       const patch = this.$store.getters.getOneStoredPatch(workingPatch.idx)
       this.patch_no = workingPatch.idx
       this.patch_name = patch.decoded.patchNameDecoded
     },
     sel_midi_device_input(newValue, oldValue) {
       //this.$store.commit('onUpdateSelectedMidiDevice', {type: 'input', value: newValue})
       console.log('[sel_midi_device_input]')
       console.log(`[input] new=[${newValue}] old=[${oldValue}]`)
       console.log(`[output] now=[${this.sel_midi_device_output}]`)
       if (this.sel_midi_device_output==null || newValue==null) {
         this.$set(this.$data, 'select_midi_device_btn_disabled', true)
       } else {
         this.$set(this.$data, 'select_midi_device_btn_disabled', false)
       }
     },
     sel_midi_device_output(newValue, oldValue) {
       //this.$store.commit('onUpdateSelectedMidiDevice', {type: 'output', value: newValue})
       console.log('[sel_midi_device_output]')
       console.log(`[input] now=[${this.sel_midi_device_input}]`)
       console.log(`[output] new=[${newValue}] old=[${oldValue}]`)
       if (this.sel_midi_device_input==null || newValue==null) {
         this.$set(this.$data, 'select_midi_device_btn_disabled', true)
       } else {
         this.$set(this.$data, 'select_midi_device_btn_disabled', false)
       }
     },
     midi_device_dialog(dialog_state) {
       switch(dialog_state) {
         case true:
           this.listMidiDevices.bind(this)()
           //console.log(this.midi_devices)
           break
         case false:
           break
         default:
           break
       }
     }
   },
   mounted: function() {
     this.$store.commit('onUpdateDemoMode', {value: this.$data.demoModeDefault})
     if (this.$data.demoModeDefault) {
         this.$router.app.$children[0].switchDemoDevicePatchesApp(this.$data.demoModeDefault)
     }
   },
   methods: {
     dump_params: function() {
       console.log(`[local:${this.label}:ewi4ksd]`, this.$data.globalVar.libs.ewi4ksd)
     },
     sendArrayChannelMessage: async function(arr_message=[]) {
       if (arr_message.length > 0) {
         if (this.$store.getters.isUsingBleMIDI()) {
           const characteristic = this.$data.globalVar.libs.bleUtil.getCharacteristic()
           await characteristic.output.send(arr_message)
         } else {
           this.$data.globalVar.libs.ewi4ksd.sendArrayChannelMessage(arr_message)
         }
       }
     },
     handleDeviceCommunicationDialog: function(open = false) {
       this.$set(this.$data, 'midi_device_dialog', open)
       this.$set(this.$data.midi_device_alert_message, 'show', false)
       //this.midi_device_dialog = open
     },
     cancelMultiplePatches: function() {
       const btnText = this.component_overly_w_dialog.btnText.toLocaleLowerCase()
       const range = this.$data.mutiple_fetch_menu.value
       switch(btnText) {
         case 'close':
           this.$set(this.$data.component_overly_w_dialog, 'show', false)
           if (this.component_overly_w_dialog.timerId>0) {
             clearTimeout(this.component_overly_w_dialog.timerId)
             this.$set(this.$data.component_overly_w_dialog, 'timerId', 0)
           }
           break;
         case 'stop':
           this.$set(this.$data.component_overly_w_dialog, 'text', `Fetching canceled. Fetched: ${this.component_overly_w_dialog.progressValueNum} / ${range[1] - range[0]}`)
           this.$set(this.$data.component_overly_w_dialog, 'btnText', 'Close')
           this.$set(this.$data.component_overly_w_dialog, 'btnColor', 'primary')
           this.$set(this.$data.component_overly_w_dialog, 'progressStream', false)
           this.$set(this.$data, 'mutiple_fetch_isCanceled', true)
           this.component_overly_w_dialog.timerId = setTimeout( () => {
             this.$set(this.$data.component_overly_w_dialog, 'show', false)
             this.$set(this.$data.component_overly_w_dialog, 'text', '')
             this.$set(this.$data.component_overly_w_dialog, 'progressStream', true)
             this.$set(this.$data, 'mutiple_fetch_isCanceled', false)
           }, this.component_overly_w_dialog.closeDialogShowDuration)
           break;
       }
     },
     sleep: async (msec=0) => {
       new Promise(resolve => setTimeout(resolve, msec))
     },
     fetchMutiplePatches: async function() {
       this.$set(this.$data.mutiple_fetch_menu, 'show', false)
       const sleep = msec => new Promise(resolve => setTimeout(resolve, msec))
       const range = this.$data.mutiple_fetch_menu.value
       this.$set(this.$data.component_overly_w_dialog, 'btnColor', 'red')
       this.$set(this.$data.component_overly_w_dialog, 'btnText', 'Stop')
       this.$set(this.$data.component_overly_w_dialog, 'show', true)
       this.$set(this.$data.component_overly_w_dialog, 'btnDisabled', false)
       this.$set(this.$data.component_overly_w_dialog, 'progressStream', true)
       for(let i=range[0]; i<=range[1]; i++) {
         // handle when canceled
         if (this.mutiple_fetch_isCanceled) {
           this.$set(this.$data, 'mutiple_fetch_isCanceled', false)
           return
         }
         const progress = Math.floor(100 * ((i - range[0])/(range[1] - range[0])))
         this.$set(this.$data.component_overly_w_dialog, 'progressValue', progress)
         this.$set(this.$data.component_overly_w_dialog, 'text', `Fetched: ${i-range[0]} / ${(range[1] - range[0])}  (#${range[0]} - ${range[1]})`)
         this.$set(this.$data.component_overly_w_dialog, 'progressValueNum', i)
         await this.fetchOnePatchFromEwi4ks(i)
         await sleep(500)
         //const storedPatch = this.$store.getters.getOneStoredPatch(i)

         // scroll Patch List
         const scrool_to = i-1
         if (scrool_to > 0 && i<range[1]) {
           const elem = document.querySelector('div#patch-list').querySelector(`#patchno-${scrool_to}`)
           elem.scrollIntoView({
             behavior: 'smooth'
           })
         }
         await sleep(500)
       }
       this.$set(this.$data.component_overly_w_dialog, 'btnColor', 'primary')
       this.$set(this.$data.component_overly_w_dialog, 'btnText', 'close')
       this.$set(this.$data.component_overly_w_dialog, 'text', 'Fetching completed!!!')
       setTimeout(() => {
         this.$set(this.$data.component_overly_w_dialog, 'show', false)
         this.$set(this.$data.component_overly_w_dialog, 'btnColor', 'red')
         this.$set(this.$data.component_overly_w_dialog, 'progressValue', 0)
         this.$set(this.$data.component_overly_w_dialog, 'component_overly_w_dialog.text', '')
       }, this.component_overly_w_dialog.closeDialogShowDuration)

     },
     _blinkOnStateChange: function() {
       if (this.midi_on_state_change.timerId!=null) {
         clearTimeout(this.midi_on_state_change.timerId)
         this.midi_on_state_change.timerId=null
       }
       this.midi_on_state_change.color = this.midi_on_state_change.color_set.changed
       this.midi_on_state_change.timerId = setTimeout( () => {
         this.midi_on_state_change.color = this.midi_on_state_change.color_set.normal
       }, 800)
     },
     onStateChangeCallback: function(ret_midi_devices) {
       // vvv blink mdi-midi-port vvv
       this._blinkOnStateChange.bind(this)()
       // ^^^ blink mdi-midi-port ^^^
       this.setMidiDevicesToList.bind(this)({devices: ret_midi_devices})
       const midiConfig = this.$store.getters.getConfigMidiDeveice()
       if (midiConfig.input != null) {
         let input_found = false
         for (let i=0; i<ret_midi_devices.inputs.length; i++) {
           if (ret_midi_devices.inputs[i].id == midiConfig.input) {
             input_found = true
             break
           }
         }
         if (!input_found) {
           this.$store.commit('onUpdateSelectedMidiDevice', {type: 'input', idx: null})
           this.$set(this.$data, 'sel_midi_device_input', null)
           console.log('-------------- onUpdateSelectedMidiDevice : input : ', this.$store.getters.getConfigMidiDeveice())
         }
       }
       if (midiConfig.output != null) {
         let output_found = false
         for (let i=0; i<ret_midi_devices.outputs.length; i++) {
           if (ret_midi_devices.outputs[i].id == midiConfig.output) {
             output_found = true
             break
           }
         }
         if (!output_found) {
           this.$store.commit('onUpdateSelectedMidiDevice', {type: 'output', idx: null})
           this.$set(this.$data, 'sel_midi_device_output', null)
         }
       }
     },
     refreshListMidiDevices: function() {
       const ret_midi_devices = this.$data.globalVar.libs.wm.getMidiDevices()
       this.setMidiDevicesToList.bind(this)({devices: ret_midi_devices})
       //this.$set(this.$data, 'is_checking_midi_device', false)
     },
     listMidiDevices: async function() {
       if (this.$store.getters.getDemoMode() == false) {
         this.$set(this.$data, 'is_checking_midi_device', false)
         this.$set(this.$data, 'select_midi_device_disabled', false)
       }
       this.$data.globalVar.libs.wm.setOnStateChangeCallback(this.onStateChangeCallback.bind(this))
       this.$data.globalVar.libs.wm
           .listMIDIDevices(this.requestMIDIAccessOption).then( ret_midi_devices => {
             console.log(ret_midi_devices)
             this.setMidiDevicesToList.bind(this)(ret_midi_devices)
           })
     },
     setMidiDevicesToList: function(ret_midi_devices = {}) {
       if (Object.keys(ret_midi_devices).length == 0) return
       this. midi_devices = {
         inputs: [],
         outputs: []
       }
       ret_midi_devices.devices.inputs.forEach( item => {
         this.midi_devices.inputs.push({
           text: item.name,
           value: item.id
         })
       })
       ret_midi_devices.devices.outputs.forEach( item => {
         this.midi_devices.outputs.push({
           text: item.name,
           value: item.id
         })
       })
     },
     startBleMidiSearch: async function() {
       if (this.ble_button.text.toLocaleLowerCase() == 'connect') {
         this.$set(this.$data.ble_button, 'loading', true)
         const connectedBleCallback = async () => {
           console.log(this.$data.globalVar.libs.bleUtil)
           if (this.$data.globalVar.libs.bleUtil.getDeviceConnected()) {
             this.$set(this.$data.ble_button, 'icon', 'mdi-bluetooth-connect')
             this.$set(this.$data.ble_button, 'text', 'Disconnect')
             this.$set(this.$data.ble_button.color, 'btn', 'blue darken-2')
             this.$set(this.$data.ble_button.color, 'text', 'white--text')
           }
           /////////////////
           const characteristic = this.$data.globalVar.libs.bleUtil.getCharacteristic()
           this.$data.globalVar.libs.ewi4ksd.setMidiDevice('output', characteristic.output)
           this.$data.globalVar.libs.ewi4ksd.setMidiDevice('input', characteristic.input)
           this.$data.globalVar.libs.ewi4ksd.requestDeviceId((event) => {console.log(event)})
         }
         this.$data.globalVar.libs.bleUtil.setConnectedBleCallback(connectedBleCallback)

         const sleep = msec => new Promise(resolve => setTimeout(resolve, msec));
         const msgToExclude = this.$data.globalVar.libs.ewi4ksd.getMsgToExclude()
         const sysExCmd = this.$data.globalVar.libs.ewi4ksd.getSysExCommand()
         const self = this
         const midiEventHandleCallback = async (event) => {
           const midimsg = event.detail
           await sleep(100)
           if (!msgToExclude.includes(midimsg[0])
               && (midimsg.slice().shift() == sysExCmd.MIDI_SYSEX_HEADER
                        && midimsg.slice().pop() == sysExCmd.MIDI_SYSEX_TRAILER) ) {
             console.log(midimsg.slice().shift(), midimsg, midimsg.slice().pop())
             const isAkaiEwi4ks = this.$data.globalVar.libs.ewi4ksd.isAkaiEwi4ks(midimsg)
             let tmp_midi_device_alert_message = {}
             if (isAkaiEwi4ks) {
               this.$store.commit('onUpdateSelectedMidiDevice', {type: 'blemidi'})
               tmp_midi_device_alert_message = {
                 text: 'EWI4000s found!',
                 type: 'success',
                 show: true
               }
               this.$set(this.$data, 'midi_device_alert_message', tmp_midi_device_alert_message)
               this.$set(this.$data, 'is_checking_midi_device', false)
               this.$set(this.$data, 'select_midi_device_disabled', false)
             } else {
               tmp_midi_device_alert_message = {
                 text: 'EWI4000s does NOT found!',
                 type: 'error',
                 show: true
               }
               this.$set(this.$data, 'midi_device_alert_message', tmp_midi_device_alert_message)
               this.$set(this.$data, 'is_checking_midi_device', false)
               this.$set(this.$data, 'select_midi_device_disabled', false)
             }
             console.log(`isAkaiEwi4ks=[${isAkaiEwi4ks}] hide_label=[${this.timeoutToHide}]`)
             setTimeout( () => {
               self.midi_checkdevice_loader = false
               tmp_midi_device_alert_message = {
                 text: '',
                 type: null,
                 show: false
               }
               self.$set(self.$data, 'midi_device_alert_message', tmp_midi_device_alert_message)
               self.$data.globalVar.libs.bleUtil.setConnectedBleCallback(() => {})
               self.$data.globalVar.libs.bleUtil.setMidiEventHandleCallback(() => {})
             }, this.timeoutToHide)
           }
         }
         this.$data.globalVar.libs.bleUtil.setMidiEventHandleCallback(midiEventHandleCallback)
         //this.$data.globalVar.libs.bleUtil.setMIDIParser( (msg) => { return msg } )

         await this.$data.globalVar.libs.bleUtil.startBle()
         this.$set(this.$data.ble_button, 'loading', false)
       } else
       if (this.ble_button.text.toLocaleLowerCase() == 'disconnect') {
         this.$data.globalVar.libs.bleUtil.endBle()
         this.$set(this.$data.ble_button, 'icon', 'mdi-bluetooth')
         this.$set(this.$data.ble_button, 'text', 'Connect')
         this.$set(this.$data.ble_button.color, 'btn', '')
         this.$set(this.$data.ble_button.color, 'text', '')
       }
     },

     checkEwi4000sDevice: async function (saveMode = false) {
       let tmp_midi_device_alert_message = {
         text: '',
         type: 'info',
         show: false
       }
       this.$set(this.$data, 'midi_device_alert_message', tmp_midi_device_alert_message)
       //
       const sel_input_id = this.sel_midi_device_input
       const sel_output_id = this.sel_midi_device_output
       if (sel_input_id===null || sel_output_id===null) {
         const tmp_midi_device_alert_message = {
           text: 'Select Ports',
           type: 'info',
           show: true
         }
         this.$set(this.$data, 'midi_device_alert_message', tmp_midi_device_alert_message)
         return
       }
       this.$set(this.$data, 'is_checking_midi_device', true)
       this.$set(this.$data, 'select_midi_device_disabled', true)

       const callback = function(res) {
         console.log(res, saveMode)
         let tmp_midi_device_alert_message = {}
         if (res.is_akai_ewi4ks){
           if (saveMode) {
             this.$store.commit('onUpdateSelectedMidiDevice', {type: 'input', idx: this.sel_midi_device_input})
             this.$store.commit('onUpdateSelectedMidiDevice', {type: 'output', idx: this.sel_midi_device_output})
             tmp_midi_device_alert_message = {
               text: 'EWI4000s found!',
               type: 'success',
               show: true
             }
             this.$set(this.$data, 'midi_device_alert_message', tmp_midi_device_alert_message)
             this.$set(this.$data, 'is_checking_midi_device', false)
             this.$set(this.$data, 'select_midi_device_disabled', false)
           } else {
             tmp_midi_device_alert_message = {
               text: 'EWI4000s found!',
               type: 'success',
               show: true
             }
             this.$set(this.$data, 'midi_device_alert_message', tmp_midi_device_alert_message)
             this.$set(this.$data, 'is_checking_midi_device', false)
             this.$set(this.$data, 'select_midi_device_disabled', false)
           }
         } else {
           tmp_midi_device_alert_message = {
             text: 'EWI4000s does NOT found!',
             type: 'error',
             show: true
           }
           this.$set(this.$data, 'midi_device_alert_message', tmp_midi_device_alert_message)
           this.$set(this.$data, 'is_checking_midi_device', false)
           this.$set(this.$data, 'select_midi_device_disabled', false)
         }
         //this.midi_checkdevice_loader = false
       }
       this._requestMidiDeviceId(callback.bind(this))
     },
     closeMidiDeviceDialog: function (update_device_select=false) {
       this.$set(this.$data, 'midi_device_dialog', false)
       if (update_device_select) {
         this.$store.commit('onUpdateSelectedMidiDevice', {type: 'input', idx: this.sel_midi_device_input})
         this.$store.commit('onUpdateSelectedMidiDevice', {type: 'output', idx: this.sel_midi_device_output})
       }
     },
     fetchOnePatchFromEwi4ks: async function(_patchNo = null) {
       // [TODO] Display error message by connection status of EWI 4000s
       this.$store.commit('onUpdateStatusExpandPanel', {value: []})
       await this._setMidiDevice(true)
       let patchNo = Number(this.patch_no_ewi)
       if (_patchNo!=null) {
         patchNo = _patchNo
       }
       console.log(`[fetchOnePatchFromEwi4ks] patchNo=[${patchNo}]`)

       const self = this
       function onMidiMessage(event, patchNo, storedPatch) {
         //const patch = self.$data.globalVar.libs.ewi4ksd.getOneStoredPatch(patchNo)
         const patch = storedPatch
         console.log('[fetchOnePatchFromEwi4ks]', storedPatch)

         //self.$store.commit('onSetWorkingPatchIdx', {idx: 'idx', value: patchNo})
         self.$store.commit('onSetStoredPatchList', {idx: JSON.parse(JSON.stringify(patchNo)), value: patch})

         const editedPatch = self.$store.getters.getOneEditPatch(patchNo)
         if (!editedPatch.fetched) {
           self.$store.commit('onSetEditPatchList', {idx: patchNo, value: JSON.parse(JSON.stringify(patch)), mode: 'update'})
         } else {
           // [TODO]
           console.error('[ERROR] Patch already exists. Need to define what should handle this case.')
         }
       }

       if (this.$store.getters.isUsingBleMIDI()) {
         const msgFetchOnePatch = this.$data.globalVar.libs.ewi4ksd.getMessageFetchOnePatch(patchNo)
         console.log(msgFetchOnePatch)
         const characteristic = this.$data.globalVar.libs.bleUtil.getCharacteristic()
         const msgToExclude = this.$data.globalVar.libs.ewi4ksd.getMsgToExclude()
         const self = this
         const midiEventHandleCallback = (event) => {
           const midimsg = event.detail
           const str_midiMsg = []
           midimsg.forEach( val => {
             str_midiMsg.push(val.toString(16))
           })
           //console.log(str_midiMsg.join(' '))
           if (!msgToExclude.includes(midimsg[0])) {
             const decodedPatch = self.$data.globalVar.libs.ewi4ksd.decodeOnePatch(patchNo, midimsg)
             self.$data.globalVar.libs.ewi4ksd.setOneStoredPatch(patchNo, midimsg, decodedPatch)
             const storedPatch = self.$data.globalVar.libs.ewi4ksd.getOneStoredPatch(patchNo)
             const patch = storedPatch
             self.$store.commit('onSetStoredPatchList', {idx: JSON.parse(JSON.stringify(patchNo)), value: patch})
             const editedPatch = self.$store.getters.getOneEditPatch(patchNo)
             if (!editedPatch.fetched) {
               self.$store.commit('onSetEditPatchList', {idx: patchNo, value: JSON.parse(JSON.stringify(patch)), mode: 'update'})
             } else {
               // [TODO]
               console.error('[ERROR] Patch already exists. Need to define what should handle this case.')
             }
           }
         }
         this.$data.globalVar.libs.bleUtil.setMidiEventHandleCallback(midiEventHandleCallback)
         characteristic.output.send(msgFetchOnePatch)
       } else {
         await this.$data.globalVar.libs.ewi4ksd.fetchOnePatch(patchNo, onMidiMessage.bind(this.$data.globalVar.ewi4ksd))
       }
     },
     showOnePatchOnUi: async function(patchNo = null, closeDialog=true, closePanels=true) {
       if (patchNo==null) return
       if (closeDialog) this.$set(this.$data, 'midi_device_dialog', false)

       // cloase all panels
       if (closePanels) {
         console.log(`MidiDeviceControls.vue:showOnePatchOnUi() closePanels=[${closePanels}]`)
         //this.$store.commit('onUpdateStatusExpandPanel', {value: []})
       }

       const applyOnePatch = async (patchNo = 0) => {
         this.$store.commit('onSetWorkingPatchIdx', {idx: 'idx', value: patchNo})
         const storedPatch = this.$store.getters.getOneStoredPatch(patchNo)
         if (storedPatch.decoded.fetched===false) return
         //console.log(`getWorkingPatchIdx=[${this.$store.getters.getWorkingPatchIdx()}]`)
         //console.log(`applyOnePatch() patchNo=[${patchNo}]`, storedPatch)

         // initialize Link switch when load(reload) new patch
         const oscFilterLink = this.$store.getters.getWorkingPatchFilterLink('oscFilter')
         const noiseFilterLink = this.$store.getters.getWorkingPatchFilterLink('noiseFilter')
         this.$store.commit('onUpdateWorkingPatchFilterLink', {idx: 'oscFilter', value: oscFilterLink})
         this.$store.commit('onUpdateWorkingPatchFilterLink', {idx: 'noiseFilter', value: noiseFilterLink})

         // check syned status
         this.$store.commit('onCheckIsWorkingPatchSynced')

         // exit demo mode to enable all button & slider etc.
         this.$store.commit('onUpdateEnableControl')

         // update synced status parametet in store
         //this.$router.app.$children[0].updateParamIsSyncedApp.bind(this)()
         this.$router.app.$children[0].updateParamIsSyncedApp()

         //this.$router.app.$children[0].repaintAllPanelApp.bind(this)()

         // for the case when load same working patch after switching between modes.
         this.$router.app.$children[0].repaintAllPanelApp()

       }
       await applyOnePatch(patchNo)

       // send program change if device is selected (hopefully connected)
       const midiConfig = this.$store.getters.getConfigMidiDeveice()
       if (midiConfig.input != null && midiConfig.output != null) {
         const internalPatchNo = this.$data.globalVar.libs.ewi4ksd.convertPatchNumToInternal(this.$store.getters.getWorkingPatchIdx())
         console.log(internalPatchNo)
         const messages = []
         // Program Change
         //messages.push(new Uint8Array([0xc0, Number(internalPatchNo)]))
         this.$router.app.$children[0].sendArrayChannelMessageApp(messages)
       }
     },
     discardParamEditOnePatch: function() {
       const patchNo = this.$store.getters.getWorkingPatchIdx()
       this.$store.commit('onDiscardSelectedPatch', {idx: patchNo})
       this.$router.app.$children[0].showOnePatchOnUiApp(patchNo, true, false)
       this.$router.app.$children[0].repaintAllPanelApp()
     },
     closeSnackbarThenOpenDeviceCommunicationDialog() {
       this.$set(this.$data.snackbar, 'show', false)
       this.$set(this.$data, 'midi_device_dialog', true)
     },
     closePatchToDeviceDialog: function() {
       this.$set(this.$data.midiSyncToDeviceMenu, 'show', false)
     },
     openSyncParamEditOnePatchToDeviceDialog: async function() {
       this.$set(this.$data.midi_device_alert_message, 'show', false)

       // check input validity in form parameter
       if (!this.$store.getters.getIsValidationOK()) {
         this.$set(this.$data.snackbar, 'icon', this.snackbar.iconSet.error)
         this.$set(this.$data.snackbar, 'text', 'Fix Patch name.')
         this.$set(this.$data.snackbar, 'btnStyle', 'display: none;')
         this.$set(this.$data.snackbar, 'timeout', -1)
         this.$set(this.$data.snackbar, 'show', true)
         return
       }

       const midiDevice = this.$store.getters.getConfigMidiDeveice()

       // [TODO] check device list and update sync to device button status

       const demoMode = this.$store.getters.getDemoMode()
       if (demoMode) {
         // hide all and display message
         this.$set(this.$data.snackbar, 'icon', this.snackbar.iconSet.warning)
         this.$set(this.$data.snackbar, 'text', 'Exit "Demo Mode" to Sync → ')
         this.$set(this.$data.snackbar, 'btnStyle', 'display: unset;')
         this.$set(this.$data.snackbar, 'timeout', -1)
         this.$set(this.$data.snackbar, 'show', true)
         return
       }

       // initialize
       this.$set(this.$data.midiSyncToDeviceMenu, 'SyncBtnIsDisabled', true)
       this.$set(this.$data.midiSyncToDeviceMenu, 'show', true)
       if (midiDevice.input==null || midiDevice.output==null) {
         this.$set(this.$data.midiSyncToDeviceMenu, 'text', 'Select EWI4000s\'s MIDI IN Port & OUT Port.')
       }
       if (demoMode===false
           || (midiDevice.input!=null || midiDevice.output!=null)) {
         this.$set(this.$data.midiSyncToDeviceMenu, 'text', 'Select EWI4000s\'s MIDI IN Port & OUT Port.')
         this.$set(this.$data.midiSyncToDeviceMenu, 'SyncBtnIsDisabled', false)
       }

       return
     },
     async sendOnePatch(encodedPatch=null, onmidimessage=() => {}, mode='store') {
       if (encodedPatch==null) {
         return
       }
       if (this.$store.getters.isUsingBleMIDI()) {
         const characteristic = this.$data.globalVar.libs.bleUtil.getCharacteristic()
         //this.$data.globalVar.libs.bleUtil.setDebugMode(true)
         this.$data.globalVar.libs.bleUtil.setMidiEventHandleCallback(() => { })
         await characteristic.output.send(encodedPatch)
         if (mode=='edit') {
           console.log('[SEND as EDIT MODE]')
           const sysExCmd = this.$data.globalVar.libs.ewi4ksd.getSysExCommand()
           encodedPatch[4] = sysExCmd.MIDI_SYSEX_MODE_EWI_EDIT
           const tmp_internalPatchNo = encodedPatch[5]
           encodedPatch[5] = 0x00
           await characteristic.output.send(encodedPatch)
           encodedPatch[5] = tmp_internalPatchNo
         }
       } else {
         await this.$data.globalVar.libs.ewi4ksd.sendOnePatch(encodedPatch, onmidimessage, mode)
       }
     },
     encodeOnePatch(editPatch_decoded) {
       return this.$data.globalVar.libs.ewi4ksd.encodeOnePatch(editPatch_decoded)
     },
     syncParamEditOnePatchToDevice: async function() {
       const midiDevice = this.$store.getters.getConfigMidiDeveice()
       if (midiDevice.input==null || midiDevice.output==null) {
         this.openSyncParamEditOnePatchToDeviceDialog()
         return
       }

       // switch button to loading
       this.$set(this.$data.midiSyncToDeviceMenu, 'loading', true)
       this.$set(this.$data, 'select_midi_device_disabled', true)
       this.$set(this.$data.midiSyncToDeviceMenu, 'closeBtnDisabled', true)

       // vvv check script vvv
       this.revealSysExDiff()
       // ^^^ check script ^^^

       // send message to store/update
       const patchNo = this.$store.getters.getWorkingPatchIdx()
       const storedPatch = this.$store.getters.getOneStoredPatch(patchNo)
       const editPatch = this.$store.getters.getOneEditPatch(patchNo)
       //const encodedPatch = this.$data.globalVar.libs.ewi4ksd.encodeOnePatch(editPatch.decoded)
       const encodedPatch = this.encodeOnePatch(editPatch.decoded)
       const arr_storedPatch = Object.values(storedPatch.hex)
       console.log('[_onSyncParamEditOnePatchToDevice:stored]', arr_storedPatch)
       console.log('[_onSyncParamEditOnePatchToDevice:edit]', encodedPatch)

       try {
         await this.sendOnePatch(encodedPatch)
         //await this.$data.globalVar.libs.ewi4ksd.sendOnePatch(encodedPatch)

         this.$store.commit('onSetStoredPatchList', {idx: patchNo, value: JSON.parse(JSON.stringify(editPatch))} )
         this.$router.app.$children[0].updateParamIsSyncedApp.bind(this)()

         // switch button to loading
         this.$set(this.$data.midiSyncToDeviceMenu, 'loading', false)
         this.$set(this.$data, 'select_midi_device_disabled', false)
         this.$set(this.$data.midiSyncToDeviceMenu, 'closeBtnDisabled', false)
         this.$set(this.$data.midiSyncToDeviceMenu, 'SyncBtnIsDisabled', true)
         this.$set(this.$data.midiSyncToDeviceMenu, 'show', false)

         // show snackbar
         this.$set(this.$data.snackbar, 'icon', this.snackbar.iconSet.success)
         this.$set(this.$data.snackbar, 'text', 'Successfully Synced!!')
         this.$set(this.$data.snackbar, 'btnStyle', 'display: none;')
         this.$set(this.$data.snackbar, 'timeout', this.timeoutToHide)
         this.$set(this.$data.snackbar, 'show', true)
       } catch (err) {
         console.log(err)
         // switch button to loading
         this.$set(this.$data.midiSyncToDeviceMenu, 'loading', false)
         this.$set(this.$data, 'select_midi_device_disabled', false)
         this.$set(this.$data.midiSyncToDeviceMenu, 'closeBtnDisabled', false)
         this.$set(this.$data.midiSyncToDeviceMenu, 'SyncBtnIsDisabled', true)
         this.$set(this.$data.midiSyncToDeviceMenu, 'show', true)

         // show snackbar
         this.$set(this.$data.snackbar, 'icon', this.snackbar.iconSet.error)
         this.$set(this.$data.snackbar, 'text', 'Something went wrong. Select ports and try again.')
         this.$set(this.$data.snackbar, 'btnStyle', 'display: none;')
         this.$set(this.$data.snackbar, 'timeout', this.timeout)
         this.$set(this.$data.snackbar, 'show', true)
       }
     },
     revealSysExDiff(patchNo=null) {
       if (patchNo==null) {
         patchNo = this.$store.getters.getWorkingPatchIdx()
       }
       const editPatch = this.$store.getters.getOneEditPatch(patchNo)
       const encodedPatch = this.$data.globalVar.libs.ewi4ksd.encodeOnePatch(editPatch.decoded)

       const storedPatch = this.$store.getters.getOneStoredPatch(patchNo)
       const arr_storedPatch = Object.values(storedPatch.hex)
       const sysexStructure = this.$data.globalVar.libs.ewi4ksd.getSysExStructure()
       const red     = '\u001b[31m'
       const green   = '\u001b[32m'
       for(let i=0; i<arr_storedPatch.length; i++) {
         const idx = i
         const isEdit = storedPatch.hex[idx]==encodedPatch[idx]
         let color = green
         if (!isEdit) {
           color=red
         }
         console.log(`${color}idx=[${idx}] paramName=[${sysexStructure.getNameByByteIdx(idx)}] isEdit=[${isEdit}] stored=[${('00'+storedPatch.hex[idx].toString(16)).substr(-2)}] encoded=[${('00'+encodedPatch[idx].toString(16)).substr(-2)}]`)
       }
     },
     exportPatches: function() {
       const allStoredPatch= this.$store.getters.getAllStoredPatch()
       let export_content = []
       allStoredPatch.forEach( patch => {
         export_content.push(JSON.stringify({
           decoded: patch.decoded,
           hex: patch.hex
         }))
       })
       this._downloadTextAsFile(export_content.join('\n--------\n'))
     },
     _downloadTextAsFile: function(content=null) {
       if (content==null) return
       const blob = new Blob([content], {type: 'text/plain'})
       const url = URL.createObjectURL(blob)
       const a = document.createElement('a')
       document.body.appendChild(a)
       a.download = `export_patch_${Date.now()}.txt`
       a.href = url
       a.click()
       a.remove()
       URL.revokeObjectURL(url)
     },
     _setMidiDevice: function(setStoreDevice=true) {
       const this_ewi4ksd = this.$data.globalVar.libs.ewi4ksd
       return new Promise( resolve => {
         this.$data.globalVar.libs.wm
             .listMIDIDevices(this.requestMIDIAccessOption)
             .then( ret_midi_access => {
               let midi_device = {}
               switch (setStoreDevice) {
                 case true:
                   midi_device = this.$store.getters.getConfigMidiDeveice()
                   break
                 case false:
                   midi_device = {
                     input: this.sel_midi_device_input,
                     output: this.sel_midi_device_output
                   }
                   break
               }
               const sel_input_id = midi_device.input
               const sel_output_id = midi_device.output

               if (sel_input_id===null || sel_output_id===null) {
                 this.midi_device_alert_message='Select Ports'
                 return
               }

               // set_midi_input
               for (let i=0; i<ret_midi_access.devices.inputs.length; i++) {
                 if (ret_midi_access.devices.inputs[i].id == sel_input_id) {
                   this.$data.globalVar.libs.ewi4ksd.setMidiDevice.bind(this_ewi4ksd)('input', ret_midi_access.devices.inputs[i])
                   break
                 }
               }
               // set_midi_output
               for (let i=0; i<ret_midi_access.devices.outputs.length; i++) {
                 if (ret_midi_access.devices.outputs[i].id == sel_output_id) {
                   this.$data.globalVar.libs.ewi4ksd.setMidiDevice.bind(this_ewi4ksd)('output', ret_midi_access.devices.outputs[i])
                   break
                 }
               }
               resolve()
             })
       })
     },
     _requestMidiDeviceId: function(_callback = null) {
       let callback = _callback
       if (callback==null) {
         callback = function(ret) {
           console.log(ret.hex_message)
           if (ret.is_akai_ewi4ks) {
             const tmp_midi_device_alert_message = {
               text: 'AKAI EWI4000s found!',
               type: 'success',
               show: true
             }
             console.log(tmp_midi_device_alert_message)
             this.$set(this.$data, 'midi_device_alert_message', tmp_midi_device_alert_message)
           }
         }
       }
       this._setMidiDevice(false).then ( async () => {
         this.midi_checkdevice_loader = true
         // [WARNING] bug callback() will NOT fired if set callbak by callback.bind(this)
         await this.$data.globalVar.libs.ewi4ksd.requestDeviceId(callback)
         setTimeout( () => {
           this.midi_checkdevice_loader = false
         }, this.timeoutToHide)
       })
     },
   }
 }
</script>

